module.exports = __webpack_public_path__ + "img/sign_out_black.3e0d79d4.svg";